<template>
    <div class="h-full w-[90%] lg:w-1/2 flex justify-center items-center">
        <div class="h-fit max-h-[98%] lg:h-fit w-full bg-white rounded-3xl relative overflow-y-auto my-5 shadow-xl">

            <div :class="[
                'text-white w-full py-5 text-lg bg-gradient-to-br from-gifty-pink to-gifty-pink_dark rounded-t-3xl flex justify-center items-center text-center font-extrabold ',
                locale === 'ar' ? 'font-arabic' : ''
            ]">
                {{ $t('register.registration_form') }}
            </div>

            <div class="w-full h-[92.625%] lg:h-[87.5%] overflow-auto p-5 flex flex-col space-y-3">
                <Stepper_container />
                <!-- Personal Info -->
                <div class="py-5 border-b border-gray-300 ">
                    <div class="text-lg  font-semibold text-gifty-text_blue mb-5 " 
                    :class="locale == 'ar' ? ' font-arabic ' : ' '">{{ $t('register.personal_info')
                    }}
                    </div>

                    <div class="w-full mt-2 grid grid-cols-1 lg:grid-cols-2 gap-4">
                        <div class="col-span-1 lg:col-span-2">
                            <label class="text-sm text-slate-600 mb-2 block"
                                :class="locale === 'ar' ? 'font-arabic' : ''">
                                {{ $t('register.full_name') }}
                            </label>
                            <input v-model="form.fullname"
                                :disabled="registerStore.user_exists && registerStore.registration?.fullname != null"
                                :class="'w-full rounded-lg border-2 border-slate-200 bg-slate-50 text-sm  placeholder-gray-500 outline-none focus:border-gifty-pink focus:border-2 transition duration-300 px-3 py-3    '
                                    + (locale == 'ar' ? ' text-lg font-arabic ' : ' ') + (inputErrors.fullname ? 'border-red-500' : 'border-gray-300')
                                    + (registerStore.user_exists && registerStore.registration?.fullname != null ? ' bg-gray-100 text-gray-400 font-semibold' : ' ')
                                    " type="text" :placeholder="$t('register.placeholders.full_name')" />
                            <p v-if="inputErrors.fullname" class="text-sm text-red-500 mt-1">
                                {{ $t(inputErrors.fullname) }}
                            </p>
                        </div>



                        <div class="col-span-1 lg:col-span-2 grid grid-cols-2 gap-4">
                            <div>
                                <label class="text-sm text-slate-600 mb-2 block"
                                    :class="locale === 'ar' ? 'font-arabic' : ''">
                                    {{ $t('register.wilaya') }}
                                </label>
                                <select v-model="form.wilaya"
                                    :disabled="registerStore.user_exists && registerStore.registration?.wilaya != null"
                                    :class="'w-full rounded-lg border-2 border-slate-200 bg-slate-50 text-sm placeholder-gray-500 outline-none focus:border-gifty-pink focus:border-2 transition duration-300 px-3 py-3     '
                                        + (locale === 'ar' ? ' font-arabic text-lg ' : ' ') + (inputErrors.wilaya ? 'border-red-500' : 'border-gray-300')
                                        + (registerStore.user_exists && registerStore.registration?.wilaya != null ? ' bg-gray-100 text-gray-400 font-semibold' : ' bg-white ')
                                        ">
                                    <option v-for="wilaya in wilayas" :key="wilaya.id" :value="wilaya"
                                        class="font-arabic">
                                        {{ wilaya.code }} - {{ locale === "ar" ? wilaya.name_ar : wilaya.name }}
                                    </option>
                                </select>
                                <p v-if="inputErrors.wilaya" class="text-sm text-red-500 mt-1">
                                    {{ $t(inputErrors.wilaya) }}
                                </p>
                            </div>

                            <div>
                                <label class="text-sm text-slate-600 mb-2 block"
                                    :class="locale === 'ar' ? 'font-arabic' : ''">
                                    {{ $t('register.commune') }}
                                </label>
                                <select v-model="form.commune"
                                    :disabled="registerStore.user_exists && registerStore.registration?.commune != null"
                                    :class="'w-full rounded-lg border-2 border-slate-200 bg-slate-50 text-sm placeholder-gray-500 outline-none focus:border-gifty-pink focus:border-2 transition duration-300 px-3 py-3   '
                                        + (locale === 'ar' ? ' font-arabic text-lg ' : '') + (inputErrors.commune ? 'border-red-500' : 'border-gray-300')
                                        + (registerStore.user_exists && registerStore.registration?.commune != null ? ' bg-gray-100 text-gray-400 font-semibold ' : ' bg-white ')
                                        ">
                                    <option v-for="commune in communes" :key="commune.id" :value="commune">
                                        {{ commune.code }} - {{ locale === "ar" ? commune.name_ar : commune.name }}
                                    </option>
                                </select>
                                <p v-if="inputErrors.commune" class="text-sm text-red-500 mt-1">
                                    {{ $t(inputErrors.commune) }}
                                </p>
                            </div>
                        </div>



                        <div class="col-span-1 lg:col-span-2">
                            <label class="text-sm text-slate-600 mb-2 block"
                                :class="locale === 'ar' ? 'font-arabic' : ''">
                                {{ $t('register.address') }}
                            </label>
                            <input v-model="form.address"
                                :disabled="registerStore.user_exists && registerStore.registration?.address != null"
                                :class="'w-full rounded-lg border-2 border-slate-200 bg-slate-50 text-sm placeholder-gray-500 outline-none focus:border-gifty-pink focus:border-2 transition duration-300 px-3 py-3    '
                                    + (locale == 'ar' ? ' text-lg font-arabic ' : ' ') + (inputErrors.address ? 'border-red-500' : 'border-gray-300')
                                    + (registerStore.user_exists && registerStore.registration?.address != null ? ' bg-gray-100 text-gray-300 font-semibold ' : ' ')

                                    " type="text" :placeholder="$t('register.placeholders.address')" />
                            <p v-if="inputErrors.address" class="text-sm text-red-500 mt-1">
                                {{ $t(inputErrors.address) }}
                            </p>
                        </div>
                    </div>
                </div>

                <!-- Commercial Info -->
                <div class=" py-5  border-b border-gray-300">
                    <div class="text-lg  font-medium text-gifty-text_blue mb-5 " 
                     :class="locale == 'ar' ? ' font-arabic ' : ' '"
                    >{{
                        $t('register.commercial_info')}}
                    </div>

                    <div class="w-full mt-2 grid grid-cols-1 lg:grid-cols-2 gap-5">
                        <div>
                            <label class="text-sm text-slate-600 mb-2 block"
                                :class="locale === 'ar' ? 'font-arabic' : ''">
                                {{ $t('register.business_number') }}
                            </label>
                            <input v-model="form.business_number"
                                :class="'w-full rounded-lg border-2 border-slate-200 bg-slate-50 text-sm  placeholder-gray-500 outline-none focus:border-gifty-pink focus:border-2 transition duration-300 px-3 py-3    ' + (locale == 'ar' ? ' text-lg font-arabic ' : ' ') + (inputErrors.business_number ? 'border-red-500' : 'border-gray-300')"
                                type="text" :placeholder="$t('register.placeholders.business_number')" />
                            <p v-if="inputErrors.business_number" class="text-sm text-red-500 mt-1"
                                :class="locale === 'ar' ? 'font-arabic' : ''">
                                {{ $t(inputErrors.business_number) }}
                            </p>
                        </div>

                        <div>
                            <label class="text-sm text-slate-600 mb-2 block"
                                :class="locale === 'ar' ? 'font-arabic' : ''">
                                {{ $t('register.shop_location') }}
                            </label>
                            <button
                                :class="'w-full rounded-lg border-2 border-slate-200 bg-slate-50 text-sm placeholder-gray-500 outline-none focus:border-gifty-pink focus:border-2 transition duration-300 px-3 py-2.5 flex justify-between items-center bg-gradient-to-b from-white to-gray-100' + (inputErrors.geolocation ? ' border-red-500' : '')"
                                @click="toggleLocationModal">
                                <div class="">{{ $t('register.placeholders.location') }}</div>
                                <div>
                                    <svg v-if="registerStore.registration.geolocation?.latitude && registerStore.registration.geolocation?.longitude"
                                        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                        class="w-6 text-emerald-500">
                                        <path fill-rule="evenodd"
                                            d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                                            clip-rule="evenodd" />
                                    </svg>

                                    <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                        fill="currentColor" class="w-6 text-[#b63753]">
                                        <path fill-rule="evenodd"
                                            d="m11.54 22.351.07.04.028.016a.76.76 0 0 0 .723 0l.028-.015.071-.041a16.975 16.975 0 0 0 1.144-.742 19.58 19.58 0 0 0 2.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 0 0-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 0 0 2.682 2.282 16.975 16.975 0 0 0 1.145.742ZM12 13.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
                                            clip-rule="evenodd" />
                                    </svg>


                                </div>
                            </button>

                            <p v-if="inputErrors.geolocation" class="text-sm text-red-500 mt-1"
                                :class="locale === 'ar' ? 'font-arabic' : ''">
                                {{ $t(inputErrors.geolocation) }}
                            </p>
                           

                        </div>

                        <div class="col-span-1 lg:col-span-2">
                             <label class="text-sm text-slate-600 mb-2 block"
                                :class="locale === 'ar' ? 'font-arabic' : ''">
                                {{ $t('register.type') }}
                            </label>
                            <select v-model="form.type"
                                :class="'w-full rounded-lg border-2 border-slate-200 bg-slate-50 text-sm placeholder-gray-500 outline-none focus:border-gifty-pink focus:border-2 transition duration-300 px-3 py-3   ' + (locale === 'ar' ? ' font-arabic text-lg ' : ' ') + (inputErrors.type ? 'border-red-500' : 'border-gray-300')">
                                <option v-for="type in types" :key="type.id" :value="type" class="font-arabic">
                                    {{ type.code }} - {{ locale === "ar" ? type.name_ar : type.name }}
                                </option>
                            </select>
                            <p v-if="inputErrors.type" class="text-sm text-red-500 mt-1"
                                :class="locale === 'ar' ? 'font-arabic' : ''">
                                {{ $t(inputErrors.type) }}
                            </p>
                        </div>

                        <div>
                            <FilesPreviewContainer :type="'poster'" @max-file-reached="showMaxFilesReachModal" />
                        </div>

                        <div>
                            <FilesPreviewContainer :type="'shop'" @max-file-reached="showMaxFilesReachModal" />
                        </div>
                    </div>
                </div>

                <!-- Account Info -->
                <div v-if="!registerStore.user_exists">
                    <div class="text-lg  font-medium text-gifty-text_blue arabic mb-5" 
                    :class="locale == 'ar' ? ' font-arabic ' : ' '"
                    >{{ $t('register.account_info') }}
                    </div>
                    <div>
                         <label class="text-sm text-slate-600 mb-2 block"
                                :class="locale === 'ar' ? 'font-arabic' : ''">
                                {{ $t('register.gifty_password') }}
                            </label>
                        <input v-model="form.password"
                            :class="'w-full rounded-lg  border-2 border-slate-200 bg-slate-50 text-sm  placeholder-gray-500 outline-none focus:border-gifty-pink focus:border-2 transition duration-300 px-3 py-3    ' + (locale == 'ar' ? ' text-lg font-arabic ' : ' ') + (inputErrors.password ? 'border-red-500' : 'border-gray-300')"
                            type="password" :placeholder="$t('register.placeholders.gifty_password')" />
                        <p v-if="inputErrors.password" class="text-sm text-red-500 mt-1"
                            :class="locale === 'ar' ? 'font-arabic' : ''"> {{ $t(inputErrors.password) }} </p>
                    </div>
                </div>


                <div>
                    <div @click="submitRegistration"
                        class="text-white w-fit  bg-gradient-to-br from-gifty-pink to-gifty-pink_dark  rounded-lg font-bold px-3 py-2 text-center mx-auto text-sm "
                        :class="locale == 'ar' ? ' font-arabic ' : ''">
                        {{ $t('register.confirm_registration') }}
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>


<script setup>
import { useI18n } from 'vue-i18n'
const { locale } = useI18n()
import { wilayas } from '@/data/wilayas';
import { dairas } from '@/data/dairas';
import { types } from '@/data/salespoint_types';
import { communes as dataCommunes } from '@/data/communes';
import { computed, ref, defineEmits, watch, onMounted, nextTick } from 'vue';
import FilesPreviewContainer from '@/components/filesPreviewContainer.vue';
import { useRegistrationStore } from '@/stores/registrationStore';
import { useRouter } from 'vue-router';
import Stepper_container from '@/components/stepper_container.vue';

const router = useRouter()



const registerStore = useRegistrationStore();

const emit = defineEmits(['toggleLoading', 'toggleMessageModal', 'toggleLocationModal']);


const form = ref({
    fullname: '',
    wilaya: wilayas[15],
    commune: null,
    address: '',
    geolocation: '',
    business_number: '',
    password: '',
    type: types[1],
});


onMounted(() => {
    if (registerStore.user_exists) {
        form.value.fullname = registerStore.registration.fullname;
        let store_wilaya_id = registerStore.registration.wilaya || 16;
        let store_commune_id = registerStore.registration.commune || 511;

        setWilayaCommuneByIds(store_wilaya_id, store_commune_id)
        form.value.address = registerStore.registration.address;
        form.value.geolocation = '';
        form.value.business_number = registerStore.registration.commerce_register_number;
        form.value.password = '';
        form.value.type = types.find(f => f.id == registerStore.registration.type?.id || f.id == 3);



    }
})
const inputErrors = ref({});

const communes = computed(() => {

    let selectedDairas = dairas.filter(d => d.wilaya_id === form.value.wilaya.id)

    return dataCommunes.filter(dc =>
        selectedDairas.some(d => d.id === dc.daira_id)
    );
});

watch(() => form.value.wilaya,
    () => {
        const relatedCommunes = communes.value;
        form.value.commune = relatedCommunes.length > 0 ? relatedCommunes[0] : null;
    },
    { immediate: true }
);

const validationRules = {
    fullname: (v) => {
        if (!v) return 'register.errors.fullname_required'
        if (v.length < 5 || v.length > 191) return 'register.errors.fullname_invalid';
        return null;
    },
    type: (v) => (v ? null : 'register.errors.type_required'),
    address: (v) => {
        if (!v) return 'register.errors.address_required';
        if (v.length < 5) return 'register.errors.address_too_short';
        if (v.length > 191) return 'register.errors.address_too_long';
        return null;
    },
    business_number: (v) => (v ? null : 'register.errors.business_number_required'),
    wilaya: (v) => (v ? null : 'register.errors.wilaya_required'),
    commune: (v) => (v ? null : 'register.errors.commune_required'),
    password: (v) => (v && v.length >= 8 ? null : 'register.errors.password_required'),
};

const validateFields = () => {
    let hasError = false;
    const errors = {};
    const skipFieldsIfUserExists = ['password', 'fullname', 'address', 'wilaya', 'commune'];

    for (const field in validationRules) {
        if (registerStore.user_exists && skipFieldsIfUserExists.includes(field) && (registerStore.registration[field] != null || field === 'password')) {

            continue;
        }

        const rule = validationRules[field];
        const error = rule(form.value[field]);
        if (error) {
            hasError = true;
            errors[field] = error;
        }
    }

    const validateFileGroup = (groupKey, errorKey) => {
        const group = registerStore.registration[groupKey];
        if (!group?.files?.length) {
            group.error = { hasError: true, message: errorKey };
            hasError = true;
        } else {
            group.error = { hasError: false, message: null };
        }
    };



    if (!registerStore.registration.geolocation?.latitude || !registerStore.registration.geolocation?.longitude) {
        errors['geolocation'] = 'register.errors.geolocation_required';
        hasError = true;
    }




    validateFileGroup('poster', 'file_required');
    validateFileGroup('shop', 'file_required');





    inputErrors.value = errors;
    return !hasError;
};

const submitRegistration = async () => {
    const isValid = validateFields();
    if (!isValid) return;

    emit('toggleLoading', true);

    try {
        const payload = {
            fullname: form.value.fullname,
            wilaya: form.value.wilaya,
            commune: form.value.commune,
            address: form.value.address,
            giftyPassword: form.value.password,
            type: form.value.type,
            commerce_register_number: form.value.business_number,
            geolocation: form.value.geolocation,
        };

        const registration_response = await registerStore.submitRegistrationData(payload);


        showMessage(registration_response.success, registration_response.message);

        if (!registration_response.success) {
            console.warn('Registration failed:', registration_response.message);
        } else {
            router.push("success_registration");
        }

    } catch (error) {
        console.error('Unexpected error during registration:', error);
        showMessage(false, "server_connection_error");
    } finally {
        emit('toggleLoading', false);
    }
};


const setWilayaCommuneByIds = (wilaya_id, commune_id) => {
    const wilaya = wilayas.find(w => w.id === wilaya_id);
    registerStore.registration.wilaya = wilaya;
    form.value.wilaya = wilaya || null;


    nextTick(() => {
        const commune = communes.value.find(c => c.id === commune_id);
        if (commune) {
            form.value.commune = commune;
            registerStore.registration.commune = commune;
        }
    });
};

const toggleLocationModal = () => {
    inputErrors.value['geolocation'] = null;
    emit('toggleLocationModal');
}


const showMessage = (success, message) => {
    emit('toggleMessageModal', true, success, message, "registration");
}

const showMaxFilesReachModal = () => {
    emit('toggleMessageModal', true, false, 'max_photos_upload', 'photos');
}



watch(
    form,
    (newForm) => {
        // Loop through each field in validation rules
        for (const field in validationRules) {
            const rule = validationRules[field];
            const error = rule(newForm[field]);
            // If the field passes validation, clear its error
            if (!error) {
                delete inputErrors.value[field];
            }
        }
    },
    { deep: true }
);
</script>
